import { createContext } from 'react'
import type { ModalContextProps } from '../provider/types'

export const ModalContext = createContext<ModalContextProps | undefined>(
    undefined
)
